
@if (config.showThumnail!=undefined && config.showThumnail && documentId) {
  <span (click)="showDocument(documentId)">
    <img class="text-center" [src]="_currentData.imageUrl| secure  | async" alt="{{_currentData.imageName}}"
      [width]="50" [height]="50">
  </span>
}
@if (!config.showThumnail && config.showTitle!=undefined && config.showTitle && documentId) {
  <a href="javascript:void(0)" (click)="showDocument(documentId);$event.stopPropagation()">{{config.showTitle |
  translate | async}}</a>
} @else {
  @if (!config.showTitle && !config.showThumnail) {
    <a href="javascript:void(0)" (click)="showDocument(documentId);">{{val |
      documentName: item:config |
    async}}</a>
  }
}
